import type { ServiceOrder } from '#domain/ServiceOrder.ts';
import type { TransportOrder } from '#domain/TransportOrder.ts';

export type OrderType = 'transport' | 'service';

export type OrderStatus = 'open' | 'planned' | 'in-transit' | 'loading' | 'unloading' | 'executing' | 'finished';

export type Order = TransportOrder | ServiceOrder;

export const isTransportOrder = (order: Order): order is TransportOrder => order.type === 'transport';
export const isServiceOrder = (order: Order): order is ServiceOrder => order.type === 'service';
